/**
 * @fileoverview ESM mirror of ../hasPermissionFor.js.
 *
 * @module @puffin-core/permissions/hasPermissionFor
 */

function hasPermissionFor(userPermissions, required) {
  if (!Array.isArray(userPermissions)) return false;
  if (typeof required !== 'string' || required.length === 0) return false;

  for (const perm of userPermissions) {
    if (typeof perm !== 'string') continue;
    if (perm === required) return true;
    if (perm === '*') return true;
    if (perm.endsWith(':*')) {
      const prefix = perm.slice(0, -1);
      if (required.startsWith(prefix)) return true;
    }
  }

  return false;
}

function hasAllPermissionsFor(userPermissions, required) {
  if (!Array.isArray(required)) return false;
  return required.every((perm) => hasPermissionFor(userPermissions, perm));
}

/**
 * @param {unknown} grant
 * @returns {boolean} Whether a grant has the wildcard shape this matcher reads (the CJS half has the rationale).
 */
function isWildcardGrant(grant) {
  return typeof grant === 'string' && (grant === '*' || grant.endsWith(':*'));
}

export { hasPermissionFor, hasAllPermissionsFor, isWildcardGrant };
